import { advancedFilters, Filters } from './filtersContext'
import { ADVANCED_SUBSCRIPTION_ID, CORE_ACCOUNT_ID, MAX_RECORDING_DAYS } from './types/DetailedView'

export type TableRowTitle = {
  ip: string
  country: string
  lastClick: string
  domain: string
  threatType: string
  count: string
  threatGroup: string
  campaignName: string
}
export type PaginationMetadata = {
  currentPage: number
  isFirstPage: boolean
  isLastPage: boolean
  nextPage: number | null
  pageCount: number | null
  previousPage: number | null
  totalCount: number | null
}

export type RowsResponse = {
  data: {
    ips: TableRowTitle[]
    count: number
    metadata: PaginationMetadata
  }
}

export type RowIdentifier = { ip: string; domain: string }[]

export const SORT_DIRECTION = {
  ASC: 'asc',
  DESC: 'desc',
} as const

export type SortDirection = (typeof SORT_DIRECTION)[keyof typeof SORT_DIRECTION]

export const ASCENDING = 'asc'
export const DESCENDING = 'desc'

export type ExpandedRow = {
  ip: string
  country: string
  lastClick: string
  threatGroup: string
  domain: string
  threatType: string
  campaign: string
  campaignName: string
  browserName: string
  browser_version: string
  os: string
  paid_id: string
  keyword?: string
  path: string
}
export type ExpandedRowsResponse = {
  clicks: ExpandedRow[]
}
export type DetailedViewRequest = {
  accountId: number
  userId: number
} & Filters

export type ExpandRowUserParams = {
  ip: string
  domain: string
  startDate: number
  endDate: number
  keyword: string | undefined
  timezone: string | null
} & advancedFilters

export type ExpandRowRequest = {
  accountId: number
  userId: number
} & ExpandRowUserParams &
  advancedFilters

// will change in the future
export const getSubscriptionType = (days?: string) => {
  return days === MAX_RECORDING_DAYS ? ADVANCED_SUBSCRIPTION_ID : CORE_ACCOUNT_ID
}
